import 'jquery';
import Backbone from 'backbone';
import 'bootstrap';
import Global from 'models/Global';
import SessionView from 'views/SessionView';
import template from 'hbars!templates/speakerPageView';
import { fetchMarkerData } from './Utils';

var SpeakerPageView = Backbone.View.extend({

    events: {
        'click .back-btn': 'backButtonClicked',
        'click .speaker-like-btn': 'likeSpeaker'
    },

    initialize: function(options) {
        options = options || {};
        this.event = options.event;
        this.sessionCollection = new Backbone.CollectionView({
            collection: this.model.get('sessions'),
            selectable: false,
            modelView: SessionView
        });
        fetchMarkerData('like', 'speakers', this);
        this.listenTo(this.model, 'speakerLike', this.renderLikeButton);
    },

    backButtonClicked: function() {
        window.history.back();
    },

    likeSpeaker: function() {
        if (this.model.get('markersData').like) {
            this.model.unLike();
        } else {
            this.model.like();
        }
    },

    renderLikeButton: function() {
        var isLiked = this.model.get('markersData').like;
        this.$('.speaker-like-btn .icon-like').toggleClass('liked', isLiked);
        this.$('.speaker-like-btn').toggleClass('liked', isLiked);
    },

    remove: function() {
        this.sessionCollection.remove();
        return Backbone.View.prototype.remove.call(this);
    },

    render: function() {
        var hasSessions = this.model.get('sessions').length > 0;
        var html = template({
            speaker: this.model.toJSON(),
            canGoBack: Global.get('canGoBack'),
            isWidget: Global.get('isWidget'),
            event: this.event.toJSON(),
            hasSessions: hasSessions
        });
        this.$el.html(html);
        this.event.get('features').agenda && hasSessions && this.sessionCollection.setElement(this.$('.sessions-list')).render();
        (!Global.get('me').isNew()) && this.model.reportView('speaker', Global.get('event').get('id'));
        return this;
    }

});

export default SpeakerPageView;


